import { ComponentProps, FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CARRIER_TYPES } from '@/lib/constants';
import { DropdownPicker } from '../dropdown-picker';

export const DropdownCarrierType: FC<
  Omit<
    ComponentProps<typeof DropdownPicker>,
    'data' | 'emptyLabel' | 'control' | 'search'
  >
> = (props) => {
  const { t } = useTranslation();

  const carrierType = CARRIER_TYPES.map((item) => ({
    ...item,
    text: t(`label.carrierTypes.${item.value}`),
  }));

  return (
    <DropdownPicker
      {...props}
      emptyLabel={t('label.carrierType')}
      data={carrierType}
      control="checkbox"
      search
    />
  );
};
